<template>
    <div style="margin-top:20px;">
        <div v-if="show">
            <van-address-edit
                :area-list="areaList"
                show-delete
                show-set-default
                show-search-result
                :area-columns-placeholder="['请选择', '请选择', '请选择']"
                @save="editonSave"
                @delete="onDelete"
                :address-info="AddressInfo"
            >
            <div class="taground">
                <div v-if="tagindex==0">
                  <van-tag round color="#ee0a24" >家</van-tag>
                  <van-tag round @click="hometag(1)" plain>公司</van-tag>
                  <van-tag round @click="hometag(2)" plain>学校</van-tag>
                </div>
                <div v-if="tagindex==1">
                  <van-tag round @click="hometag(0)" plain>家</van-tag>
                  <van-tag round color="#ee0a24">公司</van-tag>
                  <van-tag round @click="hometag(2)" plain>学校</van-tag>
                </div>
                <div v-else>
                  <van-tag round @click="hometag(0)" plain>家</van-tag>
                  <van-tag round @click="hometag(1)" plain>公司</van-tag>
                  <van-tag round color="#ee0a24">学校</van-tag>
                </div>
              </div>
            </van-address-edit>
        </div>
        <div v-else>
            <van-address-edit
                :area-list="areaList"
                show-set-default
                :area-columns-placeholder="['请选择', '请选择', '请选择']"
                @save="onSave"
            >
              <div class="taground">
                <div v-if="tagindex==0">
                  <van-tag round color="#ee0a24" >家</van-tag>
                  <van-tag round @click="hometag(1)" plain>公司</van-tag>
                  <van-tag round @click="hometag(2)" plain>学校</van-tag>
                </div>
                <div v-if="tagindex==1">
                  <van-tag round @click="hometag(0)" plain>家</van-tag>
                  <van-tag round color="#ee0a24">公司</van-tag>
                  <van-tag round @click="hometag(2)" plain>学校</van-tag>
                </div>
                <div v-else>
                  <van-tag round @click="hometag(0)" plain>家</van-tag>
                  <van-tag round @click="hometag(1)" plain>公司</van-tag>
                  <van-tag round color="#ee0a24">学校</van-tag>
                </div>
              </div>
            </van-address-edit>
        </div>
            <!-- 输入地址显示  -->
            <!-- @change-detail="onChangeDetail" -->
    </div>
</template>
<script>
import PrefectureLevel from './text.js'
import { AddressEdit, Dialog, Tag } from 'vant'
import { addDataList, memberAddress, memberAddressUpdate, memberAddressDelete } from '../../request/api.js'
export default {
  components: {
    [AddressEdit.name]: AddressEdit,
    [Tag.name]: Tag,
    [Dialog.Component.name.name]: Dialog.Component
  },
  data () {
    return {
      areaList: PrefectureLevel,
      show: false,
      AddressInfo: {},
      tagindex: 0 // 选择的标签
    //   searchResult: []
    }
  },
  methods: {
    // 17686419746
    onSave (content) {
      if (content.areaCode === '442006') {
        content.areaCode = '442100'
      } else if (content.areaCode === '442007') {
        content.areaCode = '442101'
      } else if (content.areaCode === '442008') {
        content.areaCode = '442102'
      } else if (content.areaCode === '442009') {
        content.areaCode = '442103'
      } else if (content.areaCode === '442010') {
        content.areaCode = '442104'
      } else if (content.areaCode === '442011') {
        content.areaCode = '442105'
      } else if (content.areaCode === '442012') {
        content.areaCode = '442106'
      } else if (content.areaCode === '442013') {
        content.areaCode = '442107'
      } else if (content.areaCode === '442014') {
        content.areaCode = '442108'
      } else if (content.areaCode === '442015') {
        content.areaCode = '442109'
      } else if (content.areaCode === '442016') {
        content.areaCode = '442110'
      } else if (content.areaCode === '442017') {
        content.areaCode = '442111'
      } else if (content.areaCode === '442018') {
        content.areaCode = '442112'
      } else if (content.areaCode === '442019') {
        content.areaCode = '442113'
      } else if (content.areaCode === '442020') {
        content.areaCode = '442114'
      } else if (content.areaCode === '442021') {
        content.areaCode = '442115'
      } else if (content.areaCode === '442022') {
        content.areaCode = '442116'
      } else if (content.areaCode === '442023') {
        content.areaCode = '442117'
      } else if (content.areaCode === '442024') {
        content.areaCode = '442118'
      }
      console.log(content)

      const params = {
        name: content.name,
        phone: content.tel,
        postCode: content.areaCode,
        type: this.tagindex,
        detailAddress: content.addressDetail,
        defaultStatus: Number(content.isDefault)
      }
      console.log(params)
      addDataList(params).then(res => {
        console.log(res)
        if (res.code === 200) {
          this.$router.go(-1)
          sessionStorage.getItem('addindex', 0)
        }
      }).catch(res => {
        console.log(res)
      })
    },
    changeArea(values) {
    },
    // 编辑
    editonSave (content) {
      console.log(content)
      if (content.areaCode === '442006') {
        content.areaCode = '442100'
      } else if (content.areaCode === '442007') {
        content.areaCode = '442101'
      } else if (content.areaCode === '442008') {
        content.areaCode = '442102'
      } else if (content.areaCode === '442009') {
        content.areaCode = '442103'
      } else if (content.areaCode === '442010') {
        content.areaCode = '442104'
      } else if (content.areaCode === '442011') {
        content.areaCode = '442105'
      } else if (content.areaCode === '442012') {
        content.areaCode = '442106'
      } else if (content.areaCode === '442013') {
        content.areaCode = '442107'
      } else if (content.areaCode === '442014') {
        content.areaCode = '442108'
      } else if (content.areaCode === '442015') {
        content.areaCode = '442109'
      } else if (content.areaCode === '442016') {
        content.areaCode = '442110'
      } else if (content.areaCode === '442017') {
        content.areaCode = '442111'
      } else if (content.areaCode === '442018') {
        content.areaCode = '442112'
      } else if (content.areaCode === '442019') {
        content.areaCode = '442113'
      } else if (content.areaCode === '442020') {
        content.areaCode = '442114'
      } else if (content.areaCode === '442021') {
        content.areaCode = '442115'
      } else if (content.areaCode === '442022') {
        content.areaCode = '442116'
      } else if (content.areaCode === '442023') {
        content.areaCode = '442117'
      } else if (content.areaCode === '442024') {
        content.areaCode = '442118'
      }
      const params = {
        id: this.$route.query.DataDisplay,
        name: content.name,
        phone: content.tel,
        type: this.tagindex,
        postCode: content.areaCode,
        detailAddress: content.addressDetail,
        defaultStatus: Number(content.isDefault)
      }
      console.log(params)
      memberAddressUpdate(this.$route.query.DataDisplay, params).then(res => {
        if (res.code === 200) {
          this.$router.go(-1)
        }
      })
    },
    onDelete () {
      // on confirm
      const params = {
        id: this.$route.query.DataDisplay
      }
      memberAddressDelete(this.$route.query.DataDisplay, params).then(res => {
        if (res.code === 200) {
          this.$router.go(-1)
        }
      })
    },
    hometag(i) {
      console.log(i)
      this.tagindex = i
    },
    AddressEditList () {
      if (this.$route.query.DataDisplay) {
        this.show = true
        memberAddress(this.$route.query.DataDisplay).then(res => {
          console.log(res.data)
          if (res.data.postCode === '442100') {
            res.data.postCode = '442006'
          } else if (res.data.postCode === '442101') {
            res.data.postCode = '442007'
          } else if (res.data.postCode === '442102') {
            res.data.postCode = '442008'
          } else if (res.data.postCode === '442103') {
            res.data.postCode = '442009'
          } else if (res.data.postCode === '442104') {
            res.data.postCode = '442010'
          } else if (res.data.postCode === '442105') {
            res.data.postCode = '442011'
          } else if (res.data.postCode === '442106') {
            res.data.postCode = '442012'
          } else if (res.data.postCode === '442107') {
            res.data.postCode = '442013'
          } else if (res.data.postCode === '442108') {
            res.data.postCode = '442014'
          } else if (res.data.postCode === '442109') {
            res.data.postCode = '442015'
          } else if (res.data.postCode === '442110') {
            res.data.postCode = '442016'
          } else if (res.data.postCode === '442111') {
            res.data.postCode = '442017'
          } else if (res.data.postCode === '442112') {
            res.data.postCode = '442018'
          } else if (res.data.postCode === '442113') {
            res.data.postCode = '442019'
          } else if (res.data.postCode === '442114') {
            res.data.postCode = '442020'
          } else if (res.data.postCode === '442115') {
            res.data.postCode = '442021'
          } else if (res.data.postCode === '442116') {
            res.data.postCode = '442022'
          } else if (res.data.postCode === '442117') {
            res.data.postCode = '442023'
          } else if (res.data.postCode === '442118') {
            res.data.postCode = '442024'
          }
          this.tagindex = res.data.type
          this.AddressInfo = {
            id: res.data.id,
            name: res.data.name,
            tel: res.data.phone,
            addressDetail: res.data.detailAddress,
            areaCode: res.data.postCode,
            isDefault: res.data.defaultStatus
          }
        })
      } else {
        this.show = false
      }
    }
    // onChangeDetail (val) {
    //   if (val) {
    //     this.searchResult = [{
    //       name: '黄龙万科中心',
    //       address: '杭州市西湖区'
    //     }]
    //   } else {
    //     this.searchResult = []
    //   }
    // }
  },
  created () {
    // console.log(PrefectureLevel)
    this.AddressEditList()
  }
}
</script>
<style lang="less" scoped>
  .taground{
    border-bottom:0.1px solid #ebedf0;
    height:80px;
    line-height:80px;
    padding-left: 20px;
  }
  /deep/ .van-tag{
    padding: 5px 28px;
    margin-right: 30px;
    font-size: 26px;
  }
    /deep/ .van-field__label{
        width: 140px;
        flex: initial;
        margin: auto;
    }
    /deep/ .van-cell{
      font-size: 28px;
      height: 90px;
    }
    /deep/.van-field__value{
      height: 70px;
      float: left !important;
    }
    /deep/ .van-field__body {
      width: 100%;
      float: left !important;
    }
    /deep/  .van-icon {
      font-size: 25px;
    }
    /deep/ .van-field__control{
      line-height: 50px;
    }
    /deep/.van-field__error-message{
      height: 60px;
      font-size: 22px;
    }
</style>
